import {
  Box,
  Button,
  Checkbox,
  Collapse,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  List,
  ListItem,
  Text,
  Icon,
  HStack,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import { useEffect, useState } from "react";
import { FiChevronDown, FiChevronUp, FiSearch, FiX } from "react-icons/fi";

const ModalSelectStaffYears = observer(() => {
  const { pageStore } = useStores();
  const [selectedStaffYears, setSelectedStaffYears] = useState([]);

  const staffYearsValue = ['0-0.5', '0.5-1', '1-2', '2-3', '3-4', '4+']

  useEffect(() => {
    pageStore.updateSelectedStaffYears("");
  }, []);

  const handleSelectStaffYears = (yearValue) => {
    setSelectedStaffYears((prev) => {
      const updated = prev.includes(yearValue)
        ? prev.filter((val) => val !== yearValue)
        : [...prev, yearValue];

      pageStore.updateSelectedStaffYears(updated);
      return updated;
    });
  };

  const handleSelectAll = () => {
    const updated =
      selectedStaffYears.length === staffYearsValue.length
        ? []
        : staffYearsValue;

    setSelectedStaffYears(updated);
    pageStore.updateSelectedStaffYears(updated);
  };


  return (
    <HStack alignItems={"start"} spacing={2}
      bg="#333"
      p={3}
      borderRadius="10px"
      width="250px"
      color="#EEEEEE">
      <Box position="relative" width="150px">
        <Text fontWeight={"600"} fontSize={"16px"} color={"myColor.white"}>
          Стаж (лет):
        </Text>
        <List spacing={1}>


          {staffYearsValue
            .map((item, index) => (
              <ListItem
                key={index}
                borderRadius="md"
                _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
              >
                <Checkbox
                  isChecked={pageStore.selected_staff_years.includes(
                    item
                  )}
                  onChange={() => {
                    handleSelectStaffYears(item);
                  }
                  }
                  colorScheme="blue"
                  color="myColor.white"
                >
                  {item}
                </Checkbox>
              </ListItem>
            ))}
          <ListItem
            borderRadius="md"
            _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
          >
            <Checkbox
              isChecked={
                pageStore.selected_staff_years.length > 0 &&
                pageStore.selected_staff_years.length === staffYearsValue.length
              }
              isIndeterminate={
                pageStore.selected_staff_years.length > 0 &&
                pageStore.selected_staff_years.length < staffYearsValue.length
              }
              onChange={handleSelectAll}
              colorScheme="blue"
              color="myColor.white"
            >
              <Text as="span" fontWeight="bold">
                Выбрать все
              </Text>
            </Checkbox>
          </ListItem>
        </List>
      </Box>
    </HStack>
  );
});

export default ModalSelectStaffYears;
